import { render, staticRenderFns } from "./SchedulesList.vue?vue&type=template&id=5ef126f8"
import script from "./SchedulesList.vue?vue&type=script&lang=js"
export * from "./SchedulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports